import { Banner, Button, Icon } from '@equinor/eds-core-react';
import { info_circle, mood_sad } from '@equinor/eds-icons';
import { useNavigate } from 'react-router-dom';
import * as Styled from './FullPageBanner.styled';

/* eslint-disable camelcase */
Icon.add({ mood_sad, info_circle });

type FullPageBannerVariant = 'error' | 'info';

interface FullPageBannerProps {
  message: string;
  variant?: FullPageBannerVariant;
  /** Show a "Go home" button. Defaults to true for error, false for info. */
  showHomeButton?: boolean;
}

export function FullPageBanner({
  message,
  variant = 'error',
  showHomeButton,
}: FullPageBannerProps) {
  const navigate = useNavigate();

  const showButton = showHomeButton ?? variant === 'error';

  return (
    <Styled.CenteredPage>
      <Styled.Content>
        <Banner>
          <Banner.Icon variant={variant === 'error' ? 'warning' : 'info'}>
            <Icon name={variant === 'error' ? 'mood_sad' : 'info_circle'} />
          </Banner.Icon>
          <Banner.Message>{message}</Banner.Message>
          {showButton && (
            <Banner.Actions>
              <Button onClick={() => navigate('/home')}>Go home</Button>
            </Banner.Actions>
          )}
        </Banner>
      </Styled.Content>
    </Styled.CenteredPage>
  );
}
